import React, { useEffect } from "react";

import useLayoutStore from "store/useLayoutStore";
import { Error401 } from "container/Error/Error401";
const Error401Page = () => {
  const { setLayout } = useLayoutStore();

  useEffect(() => {
    // setLayout({ isHeader: false, isSubTab: false,   });
  }, []);
  return (
    <>
      <Error401 />
    </>
  );
};

export default Error401Page;
